import { NumberFormat } from "../../components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";

export enum MetricsKind {
    UNITS = "UNITS", // Bulk units per door
    AVERAGE_UNITS = "AVERAGE_UNITS", // Avg units per door
    STORE_WITH_UNITS = "STORE_WITH_UNITS", // Count of doors with units
    TOTAL_COST = "TOTAL_COST", // Total cost per door
    TOTAL_RETAIL = "TOTAL_RETAIL", // Total retail per door
    PLAN_ROWS = "PLAN_ROWS", // If units > 0, otherwise
    IMU_PERCENTAGE = "IMU_PERCENTAGE", // Markup per door
    AUR = "AUR", // Average unit retail
    SKUS = "SKUS", // Unique product
    UNIT_ROW_PERCENTAGE_PLAN = "UNIT_ROW_PERCENTAGE_PLAN", // Units / Total units for that door
    ROW_PERCENTAGE_PLAN = "ROW_PERCENTAGE_PLAN", // Retail / Total retail for that door
    UNIT_DOOR_PERCENTAGE_PLAN = "UNIT_DOOR_PERCENTAGE_PLAN", // Units / Total units for that product row
    DOOR_PERCENTAGE_PLAN = "DOOR_PERCENTAGE_PLAN", // Retail / Total retail for that product row
    BREADTH_PERCENTAGE_PLAN = "BREADTH_PERCENTAGE_PLAN", // Plan rows / Total plan rows for that column
    AVERAGE_DEPTH = "AVERAGE_DEPTH", // Units / Plan rows
    AVERAGE_COST = "AVERAGE_COST", // Cost / Units
}

export const EditableMetrics = [MetricsKind.UNITS, MetricsKind.AVERAGE_UNITS];

export type DoorGroupMetrics = DoorGroupMetric[];

export type DoorGroupMetric = {
    show_value: boolean;
    show_totals: boolean;
    show_subtotals: boolean;
    display_name: string;
    read_only: boolean;
    kind: MetricsKind;
    number_format?: {
        currency?: {
            symbol: string;
            decimal_places: number;
            currency_code: string;
        };
        percentage?: {
            decimal_places: number;
        };
    };
    target_view?: {
        is_target_metric: boolean;
    };
};

export type Metrics = Metric[];

export type Metric = {
    showValue: boolean;
    showTotals: boolean;
    showSubtotals: boolean;
    kind: MetricsKind;
    displayName: string;
    numberFormat?: NumberFormat;
    isTargetMetric: boolean;
};

export interface MetricsDataForCell {
    doorIdValue: string;
    currentDeliveryIdValue: string;
    shouldSkip: boolean;
    bulkCount: number;
    currentSize?: string;
}
